import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Checkbox} from '@components/common/base/checkbox'
import {OptionsItemCheckbox} from '@components/common/base/dropdown-button-menu/types'
import {
  getValue,
  SelectWithCheckboxes
} from '@components/common/base/select-with-dropdown/select-with-checkboxes'
import {menuItemHeight} from './constants'
import {useMovementStore} from './movement-store'
import {TwAction} from './remove-assigned-actions'

interface Props {
  onChange?: (props: OptionsItemCheckbox[]) => void
  stickersOptions: OptionsItemCheckbox[]
}

export const UnpinStickersActions = observer((props: Props) => {
  const {stickersOptions = []} = props
  const [state, store] = useMovementStore()

  const lang = Lang.msg.movementTemplates
  const onChange = (value: OptionsItemCheckbox[]) => {
    props.onChange?.([...value])
  }

  return (
    <>
      <TwAction>
        <Checkbox
          value={!!state.unpin}
          text={lang.createUnpinStickers}
          onChange={store.unpinChanged}
        />

        <div className="max-w-230 min-w-230 ml-auto">
          <SelectWithCheckboxes
            options={stickersOptions}
            value={getValue(stickersOptions)}
            placeholder={
              Lang.msg.movementTemplates.destinationSelectStickersPlaceholder
            }
            size={menuItemHeight}
            allCaption={Lang.msg.movementTemplates.stickersAllCaption}
            disabled={!state.unpin || !stickersOptions?.length}
            onChange={onChange}
          />
        </div>
      </TwAction>
    </>
  )
})
